"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var SwiperPlug = __importStar(require("swiper/react"));
var breakpoints = {
    '0': {
        'slidesPerView': 2.5,
        'slidesPerGroup': 2.5,
    },
    '768': {
        'slidesPerView': 3.5,
        'slidesPerGroup': 3.5,
    },
    '992': {
        'slidesPerView': 4.5,
        'slidesPerGroup': 4.5,
    },
};
function Sports() {
    var sports = ra_fetch_1.useApi('backend').index('sports', { hidden: 0 })[0];
    if (sports.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Layouts.Swiper, { className: 'storybook-home-sports', spaceBetween: 10, slidesPerView: 4.5, breakpoints: breakpoints }, sports.data.map(function (sport, index) {
        return react_1.default.createElement(SwiperPlug.SwiperSlide, { key: index },
            react_1.default.createElement("div", { className: 'storybook-home-sports-card' },
                react_1.default.createElement("a", { href: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/sports/" + sport.name },
                    react_1.default.createElement("figure", { style: { backgroundImage: "url(" + sport.logo + ")" } }))));
    }));
}
exports.default = Sports;
